import { MarketStatus } from "~/types/event";

export const tradeLabelByMarketStatus: Record<MarketStatus, string> = {
  [MarketStatus.ACTIVE]: "Trade",
  [MarketStatus.RESOLVED]: "View",
  [MarketStatus.CLOSED]: "View",
  [MarketStatus.PROPOSED]: "Trade",
  [MarketStatus.DISPUTED]: "Trade",
};
